import { useState, useEffect } from "react";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Dialog,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { DialogHeader } from "./DialogHeader";
import { PickupOrder } from "./PickupOrder";
import { DeliveryOrder } from "./DeliveryOrder";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    boxShadow: "0px 3px 0px 1px #972020",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, name, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {name}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const CustomerInfoDialog = (props) => {
  const {
    onOrderSelection,
    companyName,
    pickUpTime,
    deliveryTime,
    onTextChange,
    onEMailChange,
    onPhoneChange,
    onDateChange,
    onTimeChange,
    onAlert,
    customerData,
    tabNumber,
    onChangeNumber,
    onNumberChange,
    onAddressChange,
    onShowClock,
    showClock,
    typesettings,
  } = props;
  const { DeliveryOrderOptions, PickupOrderOptions } = typesettings;
  //const [value, setValue] = useState(0);

  /*const handleChange = (event, newValue) => {
    setValue(newValue);
  };*/

  return (
    <Box>
      <DialogContent dividers>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabNumber}
              onChange={onChangeNumber}
              aria-label="basic tabs example"
              centered
            >
              {PickupOrderOptions == 1 ? (
                <Tab label="Pickup" {...a11yProps(0)} />
              ) : null}
              {DeliveryOrderOptions == 1 ? (
                <Tab label="Delivery" {...a11yProps(1)} />
              ) : null}
            </Tabs>
          </Box>
          <TabPanel value={tabNumber} index={0}>
            <PickupOrder
              companyName={companyName}
              onOrderSelection={onOrderSelection}
              pickUpTime={pickUpTime}
              onTextChange={onTextChange}
              onEMailChange={onEMailChange}
              onPhoneChange={onPhoneChange}
              onDateChange={onDateChange}
              onTimeChange={onTimeChange}
              onAlert={onAlert}
              customerData={customerData}
              onShowClock={onShowClock}
              showClock={showClock}
            />
          </TabPanel>
          <TabPanel value={tabNumber} index={1}>
            <DeliveryOrder
              companyName={companyName}
              onOrderSelection={onOrderSelection}
              deliveryTime={deliveryTime}
              onTextChange={onTextChange}
              onEMailChange={onEMailChange}
              onPhoneChange={onPhoneChange}
              onDateChange={onDateChange}
              onTimeChange={onTimeChange}
              onAlert={onAlert}
              customerData={customerData}
              onShowClock={onShowClock}
              showClock={showClock}
              onNumberChange={onNumberChange}
              onAddressChange={onAddressChange}
            />
          </TabPanel>
        </Box>
      </DialogContent>
    </Box>
  );
};
